import React from 'react'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'

import { useStyles } from '../styles'
import TableAA from '../../Tables/TableAA'

const EnduroMarketCard = (props) => {
  const { total = [], selectedDate, gTotal } = props
  const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Mercado ENDURO</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3} justifyContent='center'>
          <Grid item xs={12} sm={12} lg={12}>
            <TableAA array={total} selectedDate={selectedDate} disableAA />
          </Grid>
          <Grid item xs={12} sm={10} lg={10}>
            <h3>Evolución ENDURO en miles</h3>
            <br />
            <Bar
              data={Utils.simpleBarLine(
                gTotal,
                'Y',
                'CANT',
                'VARIACION',
                'Año',
              )}
              options={Utils.optionsSimpleBarChart}
            />{' '}
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default EnduroMarketCard
